import { render, staticRenderFns } from "./RoleUpdated.vue?vue&type=template&id=3d64fca9&scoped=true"
import script from "./RoleUpdated.vue?vue&type=script&lang=js"
export * from "./RoleUpdated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d64fca9",
  null
  
)

export default component.exports